import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./trainers.css";
import trainerImg from "../../assets/testingimages/otherimages/ourtraining.jpg";

function Trainers() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <section className="trainers-section">
      <div className="container">

        <section>
          <div className="headlines-for-all" data-aos="fade-up">
            <h4>
              <span>Our </span> Trainers
            </h4>
          </div>
        </section>

        <div className="trainers-content">

          {/* Left text area */}
          <div className="trainers-text">
            <p data-aos="fade-up" data-aos-delay="100">
              At{" "}
              <strong>
                <span className="fazo-fazo"> Fazo Academy </span>
              </strong>
              , we are committed to delivering a{" "}
              <strong>
                comprehensive blend of theoretical knowledge and practical skills
              </strong>{" "}
              in Frontend Development through our expertise in{" "}
              <strong>industry-focused training</strong>.
            </p>

            <p data-aos="fade-up" data-aos-delay="200">
              Our <strong>experienced Frontend Development instructors</strong> specialize in{" "}
              <strong>modern UI development and responsive web design</strong>{" "}
              techniques, ensuring students develop{" "}
              <strong>real-world frontend expertise</strong>.
            </p>

            <p data-aos="fade-up" data-aos-delay="300">
              Students gain hands-on experience with{" "}
              <strong>various frontend technologies</strong>, including{" "}
              <strong>
                HTML, CSS, JavaScript, React.js, Bootstrap, and Tailwind CSS.
              </strong>
            </p>

            <p data-aos="fade-up" data-aos-delay="400">
              Our <strong>specialized training programs</strong> cover industry-leading
              tools and workflows like{" "}
              <strong>
                Git, GitHub, Responsive Design, API Integration, and Browser DevTools
              </strong>
              , enabling students to become proficient in{" "}
              <strong>building modern, responsive web interfaces</strong>.
            </p>

            <p data-aos="fade-up" data-aos-delay="500">
              Our <strong>dedicated Frontend trainer</strong> designs personalized training
              modules that include{" "}
              <strong>
                real-time UI projects, component development, API integration, deployment,
                and interview preparation
              </strong>{" "}
              through hands-on coding sessions.
            </p>
          </div>
          {/* Right image */}
          <div className="trainers-image">
            <img
              src={trainerImg}
              alt="Trainers"
              data-aos="zoom-in"
              data-aos-delay="300"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Trainers;
